import script from "./DeploymentChannelsOptionsSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./DeploymentChannelsOptionsSelector.vue?vue&type=script&setup=true&lang=js"

import "./DeploymentChannelsOptionsSelector.vue?vue&type=style&index=0&id=b85ec5aa&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b85ec5aa"]])

export default __exports__